import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22layout.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/GeistMonoVF.woff%22,%22variable%22:%22--font-geist-mono%22,%22weight%22:%22100%20900%22}],%22variableName%22:%22geistMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'geistMono', 'geistMono Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
